import {
    disconnectAccountLink
} from "@/api/fintoc";

export default {
    state: {},
    mutations: {},
    actions: {
        // eslint-disable-next-line no-unused-vars
        disconnectAccountLink({ commit }, id) {
            return new Promise((resolve, reject) => {
                disconnectAccountLink(id)
                    .then(() => {
                        resolve(id);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    getters: {
    },
    namespaced: true,
};
